import React, { useMemo, useState } from 'react';
import { KeyMetricGraphBox } from 'src/components/organisms/KeyMetricGraphBox';
import { TimeseriesDataTableModal } from 'src/components/organisms/TimeseriesDataTableModal';
import { useCurrency } from 'src/hooks/useCurrency';
import { useMergeBenchmarkTimeseries } from 'src/hooks/useMergeBenchmarkTimeseries';
import {
  KeyMetricsDateFormatter,
  currencyValueTickFormatter,
} from 'src/utils/TickFormatters';
import { SPEND_DEF } from 'src/utils/metricDefinitions';
import { useDADataContext } from '../../contexts/DADataContext';

const title = 'Spend';

export const SpendOTBox: React.FC = () => {
  const { investments, benchmarkInvestments } = useDADataContext();
  const { getMergedTimeSeries } = useMergeBenchmarkTimeseries();
  const { code } = useCurrency();
  const investmentTickFormatter = currencyValueTickFormatter(code);

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const data = useMemo(() => {
    return getMergedTimeSeries(
      investments.daily,
      benchmarkInvestments.daily,
      (v) => ({ value: v.totalInvestment }),
      (v) => ({ benchmark: v.totalInvestment }),
      false,
      'day',
    );
  }, [investments, benchmarkInvestments, getMergedTimeSeries]);

  return (
    <KeyMetricGraphBox
      title={title}
      legendLabel={title}
      data={data}
      xAxisFormatter={KeyMetricsDateFormatter}
      yAxisFormatter={investmentTickFormatter}
      isError={investments.isError}
      isLoading={investments.isLoading}
      infoText={SPEND_DEF}
      exportEnabled
      onTableModalOpen={setModalIsOpen}
      tableModal={
        <TimeseriesDataTableModal
          isOpen={modalIsOpen}
          setIsOpen={setModalIsOpen}
          yFormatter={investmentTickFormatter}
          dateFormatter={KeyMetricsDateFormatter}
          data={data}
          headerName={title}
        />
      }
    />
  );
};
